import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0df025c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column is-centered" }
const _hoisted_3 = { class: "payment" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    opacity: "0.8",
    cx: "26.5",
    cy: "26.5",
    r: "26.5",
    fill: "#76B13A"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.3521 33.0472L17.1362 26.8313L15.0195 28.9331L23.3521 37.2656L41.2396 19.3781L39.1378 17.2764L23.3521 33.0472Z",
    fill: "white"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Partial Payment Received", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Thank you. Your partial payment of")
const _hoisted_8 = { class: "mx-1" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("has been received. ")
const _hoisted_10 = { class: "mx-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("to complete your payment")
const _hoisted_12 = { class: "wire-instructions" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "has-text-weight-light text-left" }, "Wire Number", -1))
const _hoisted_14 = { class: "wire-info is-flex" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "button"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-spin mdi-loading" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "23",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.6153 0.205139H2.30763C1.17942 0.205139 0.256348 1.12822 0.256348 2.25642V16.6154H2.30763V2.25642H14.6153V0.205139ZM13.5897 4.3077L19.7435 10.4615V20.718C19.7435 21.8462 18.8204 22.7692 17.6922 22.7692H6.39994C5.27173 22.7692 4.35891 21.8462 4.35891 20.718L4.36917 6.35898C4.36917 5.23078 5.28199 4.3077 6.41019 4.3077H13.5897ZM12.564 11.4872H18.2051L12.564 5.84616V11.4872Z",
    fill: "#828C99"
  })
], -1))
const _hoisted_20 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_21 = {
  key: 0,
  class: "amount"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Amount outstanding:", -1))
const _hoisted_23 = { class: "mt-2 has-text-weight-semibold" }
const _hoisted_24 = {
  key: 1,
  class: "amount"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ph mb-3" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ph" }, null, -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceSteps = _resolveComponent("InvoiceSteps")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_InvoiceSteps, {
      steps: _ctx.steps,
      currentStep: 5,
      currentColour: "#F2994A"
    }, null, 8, ["steps"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (_ctx.invoice.contact)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("b", _hoisted_8, _toDisplayString(_ctx.currency(_ctx.invoice.total_price, _ctx.invoice.currency, 2, true)), 1),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _createTextVNode(" Payment details and receipt will be sent to your email " + _toDisplayString(_ctx.invoice.contact.email) + ". Wire the remainder of", 1),
            _createElementVNode("b", _hoisted_10, _toDisplayString(_ctx.currency(_ctx.invoice.outstanding_amount, _ctx.invoice.currency, 2, true)), 1),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("input", {
                class: "input",
                value: _ctx.accountNumber,
                type: "text",
                readonly: ""
              }, null, 8, _hoisted_15),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_16, _hoisted_18))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyAccountNumber && _ctx.copyAccountNumber(...args))),
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = true)),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = false))
                  }, [
                    _hoisted_19,
                    (_ctx.showTooltip)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Copy wire number"))
                      : _createCommentVNode("", true)
                  ], 32))
            ]),
            (_ctx.invoice.uuid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.currency(_ctx.invoice.outstanding_amount, _ctx.invoice.currency, 2, true)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
          ])
        ])
      ])
    ])
  ], 64))
}